
import { Route } from 'react-router-dom';
import MyPerformance from '../../components/work-reports/my-performance/MyPerformance';
import SubmitReport from '../../components/work-reports/submit-report/SubmitReport';
import EmptyLayout from '../../components/layouts/empty-layout/EmptyLayout';
export default function WorkReportRoute() {

    return <>
        <Route element={<EmptyLayout />}>
            <Route path="/RegisterReport" element={<SubmitReport />} />
            <Route path="/MyPerformance" element={<MyPerformance />} />
        </Route>
    </>
}